import React from 'react'
import {Stack, Text} from '../../../vanilla'
import {ErrorMessageConfig} from '../../../utils/constants'
import {Link} from 'react-router-dom'

interface CheckoutErrorMessageProps {
  error: ErrorMessageConfig | string
  isTopUpPage: boolean
}

export const CheckoutErrorMessage = ({error, isTopUpPage}: CheckoutErrorMessageProps) => {
  const {message, showErrorHeading, includeCustomerCare, customLink} = error as ErrorMessageConfig

  const CustomerCareLink = () => (
    <>
      {' '}
      If this is not the first time you have seen this message, please{' '}
      <Text
        variant="text4"
        lineHeight="shorter"
        color="accent0"
        as={Link}
        to="/customer-support/contact-us"
        textDecoration="underline"
      >
        contact our Customer Care team
      </Text>{' '}
      for assistance.
    </>
  )

  return (
    <Stack paddingX={['16px', '20px']} paddingY={['20px', '24px']} style={{background: '#F9E5E9'}}>
      {showErrorHeading && (
        <Text variant="heading1" lineHeight="shorter" color="accent0">
          Unable to {isTopUpPage ? 'top up your Bonus Card' : 'place order'}
        </Text>
      )}
      <Text variant="text4" lineHeight="shorter" color="accent0">
        {message ?? error}
        {customLink && 
          <Link to={{pathname: `${customLink.pathname ?? '/'}`, state: {redirectTo: `${customLink.redirectTo ?? '/'}`}}}>
            <Text
              as="span"
              variant="text4"
              lineHeight="shorter"
              color="accent0"
              textDecoration="underline"
            >
              {customLink.text ?? ''}
            </Text>
          </Link>
        }
        {includeCustomerCare && <CustomerCareLink />}
      </Text>
    </Stack>
  )
}
